module.exports = __webpack_public_path__ + "img/ch09_12_转圈拍照.5e7238b1.jpg";